import { StanButton } from '@/components';
import { useModal } from '@/hooks/useModal';
import { useParams } from 'react-router-dom';
import { useUser } from '@/queries';
import { TestSendModal } from './TestSendModal';
import { useFormContext } from 'react-hook-form';
import type { EmailFormData } from '../types';

interface EmailFormActionsProps {
    onSaveAsDraft: () => void;
    onPublish: () => void;
    disabled?: boolean;
    isSaving?: boolean;
}

export const EmailFormActions = ({
    onSaveAsDraft,
    onPublish,
    disabled = false,
    isSaving = false,
}: EmailFormActionsProps) => {
    const testSendModal = useModal();
    const { flowId, emailId } = useParams<{ flowId: string; emailId: string }>();
    const { user } = useUser();

    // Get current form values
    const { watch } = useFormContext<EmailFormData>();
    const subject = watch('subject');
    const body = watch('body');

    const parsedFlowId = Number(flowId) || -1;
    const parsedEmailId = emailId ? Number(emailId) || -1 : undefined;

    return (
        <>
            <div className='flex flex-col gap-x-3 sm:flex-row'>
                {/* Mobile: Test Send and Save Draft side by side, Desktop: Only Test Send */}
                <div className='flex gap-2 sm:block'>
                    <StanButton
                        name='email-actions-menu'
                        type='button'
                        variant='outline'
                        onClick={testSendModal.open}
                        disabled={disabled || isSaving}
                        className='flex-1 sm:w-auto'
                    >
                        Test Send
                    </StanButton>
                    <StanButton
                        name='email-actions-menu'
                        type='button'
                        variant='outline'
                        onClick={onSaveAsDraft}
                        disabled={disabled || isSaving}
                        loading={isSaving}
                        className='flex-1 sm:hidden!'
                    >
                        Save Draft
                    </StanButton>
                </div>
                {/* Desktop: Spacer */}
                <div className='flex-1' />
                <div className='flex flex-col gap-2 sm:flex-row'>
                    <StanButton
                        name='email-actions-menu'
                        type='button'
                        variant='outline'
                        onClick={onSaveAsDraft}
                        disabled={disabled || isSaving}
                        loading={isSaving}
                        className='max-sm:hidden! sm:block'
                    >
                        Save Draft
                    </StanButton>
                    <StanButton
                        name='email-actions-menu'
                        type='button'
                        onClick={onPublish}
                        disabled={disabled || isSaving}
                        loading={isSaving}
                        className='w-full sm:w-auto'
                    >
                        Publish
                    </StanButton>
                </div>
            </div>

            <TestSendModal
                isOpen={testSendModal.isOpen}
                defaultEmail={user?.email || ''}
                onClose={testSendModal.close}
                flowId={parsedFlowId}
                emailId={parsedEmailId}
                subject={subject}
                body={body}
            />
        </>
    );
};
